import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('profile', 'mfa-notice');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'mfa_settings',
  type: 'post',
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/profiles/mfa-notice.js